import React from 'react';

type Props = {
  className: string;
};

const InstallSvg: React.FC<Props> = (props: Props) => {
  return (
    <svg
      className={props.className}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.559 10.898L16.388 2.971C16.2735 2.68426 16.0757 2.43845 15.8201 2.26535C15.5644 2.09225 15.2627 1.99981 14.954 2H12.52L12.9 6.065H15.6L10.5 10.293L5.4 6.065H8.1L8.48 2H6.046C5.414 2 4.846 2.384 4.612 2.971L1.441 10.898C1.1531 11.6187 1.06803 12.4044 1.195 13.17L1.785 16.709C1.84491 17.0697 2.03086 17.3974 2.30975 17.6338C2.58865 17.8702 2.94239 18 3.308 18H17.691C18.446 18 19.09 17.454 19.214 16.709L19.804 13.17C19.9328 12.4045 19.8481 11.6184 19.559 10.898ZM17.459 15.245C17.4241 15.4561 17.3154 15.6479 17.1522 15.7862C16.989 15.9245 16.7819 16.0003 16.568 16H4.432C4.21807 16.0003 4.01102 15.9245 3.84781 15.7862C3.6846 15.6479 3.57586 15.4561 3.541 15.245L3.176 13.052C3.15417 12.9226 3.16085 12.7899 3.19559 12.6633C3.23034 12.5367 3.29229 12.4192 3.37714 12.319C3.46198 12.2189 3.56767 12.1384 3.68682 12.0833C3.80597 12.0282 3.93572 11.9998 4.067 12H16.934C17.492 12 17.917 12.501 17.825 13.052L17.459 15.245Z"
        fill="white"
      />
    </svg>
  );
};

export default InstallSvg
